import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/yeppy/banner_img.jpg";

const Banner = () => {
  return (
    <div className="banner_yeppy" style={{ backgroundImage: `url(${BgImg})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={4} xxl={4} className="my-auto">
            <StaticImage
              src="../../../images/case-studies/yeppy/logo.png"
              alt="TekRevol"
              className="img-fluid logo_img"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={228}
              height={61}
            />
            <div className="case_heads">
              <h5>CASE STUDY</h5>
            </div>

            <h1>Super App Yeppy</h1>
            <h4>All Your Needs, One App!</h4>
          </Col>

          <Col xs={12} md={6} lg={7} xl={8} xxl={8} className="my-auto">
            <div className="case_right_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/yeppy_banner_img.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1129}
                height={829}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
